import React from "react";
import financeApiService from "../../../../services/financeApiService";
import ChampLibreDossier from "./ChampLibreDossier";

// LS-716 — n° de contrat attribué par le financeur, saisi à la main dès
// "Accord reçu" (champ libre, max 30 caractères, ressaisie possible en cas
// d'erreur). Affiché dans le bandeau KPI du détail ; la valeur sert ensuite
// de clé de recherche dans la liste des demandes et l'encours CB.
const NumeroContratFinanceur = ({
  demandeUuid,
  numeroContrat,
  canEdit,
  onSaved,
}) => (
  <ChampLibreDossier
    libelle="N° contrat financeur"
    libelleTitre="n° de contrat"
    valeur={numeroContrat}
    canEdit={canEdit}
    placeholder="Ex. CB-2026-042"
    enregistrer={(numero) =>
      financeApiService.saisirNumeroContrat(demandeUuid, numero)
    }
    messageSucces="N° de contrat financeur enregistré."
    messageErreur="L'enregistrement du n° de contrat a échoué."
    onSaved={onSaved}
  />
);

export default NumeroContratFinanceur;
